module.exports = __webpack_public_path__ + "static/media/ccna_logo.0c7180fb.jpg";